import React from "react";
import styled from "styled-components";
import { Business, StarBorder, Star, LocationOn } from "@material-ui/icons";

import getIconFromId from "utils/getIconFromId";
import setCoordinates from "utils/setGoogleMapsCoordinates";

import { BREAKPOINT } from "./constants";

const HeaderResults = styled.div`
  font-weight: bold;
  color: ${({ theme }) => theme.black75};
`;
const ContentResults = styled.div`
  color: ${({ theme }) => theme.black100};
`;
const SingleResultContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0px;
  cursor: pointer;
`;
const IconContainer = styled.div`
  margin-right: 5px;
  padding: 10px;
`;

const FlexContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Branch = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 195px;
  background-color: ${({ theme }) => theme.primaryHover};
  border-radius: 2px;
  display: inline-block;
  margin: 2px;
  min-width: 0;
  box-sizing: border-box;
  color: white;
  font-size: 85%;
  overflow: hidden;
  padding: 3px;
  padding-left: 6px;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const ImgHolder = styled.div`
  width: 20px;
  height: 20px;
  top: 0px;
  z-index: 9;
  display: inline-block;
  margin-right: 10px;
`;
const Img = styled.img`
  background: transparent;
  margin-left: -20px;
  width: 100%;
`;
const ButtonMore = styled.button`
  color: ${({ theme }) => theme.interactionColor};
  background: none;
  border: none;
  cursor: pointer;
`;
const FlexContainerBranches = styled(FlexContainer)`
  flex: 1 1;
  flex-flow: row wrap;
  @media (max-width: ${BREAKPOINT}) {
    display: none;
  }
`;

function renderCompany(
  company,
  setSelectedCompany,
  setToggleModal,
  handleCompanyFavorite,
  setSelectedRoute,
  selectedRoute,
  channels,
  theme,
  showMore,
  setShowMore,
  scrollTo,
  index
) {
  if (!company) {
    return (
      <SingleResultContainer>
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <IconContainer>
            <Business />
          </IconContainer>
          <div>
            <HeaderResults>wird geladen...</HeaderResults>
            <ContentResults>wird geladen...</ContentResults>
          </div>
        </div>
        <IconContainer>
          <StarBorder />
        </IconContainer>
      </SingleResultContainer>
    );
  }
  const text = `${company.co_street ? company.co_street : ""}${company.co_street ? "," : ""} ${
    company.co_zip ? company.co_zip : ""
  } ${company.co_city ? company.co_city : "-"}, ${company.co_phone ? company.co_phone : "-"}`;

  const foundRoute = selectedRoute.find(comp => comp.id === company.id);
  const branches = company?.company_wz2008;
  const showStar = company?.co_street && company?.co_city && company?.co_zip;

  return (
    <SingleResultContainer
      onClick={async () => {
        const updatedCompany = await setCoordinates(company);
        setSelectedCompany(updatedCompany);
        setToggleModal(0);
      }}
    >
      <FlexContainer style={{ flex: "1 1" }}>
        <IconContainer>
          <Business />
        </IconContainer>
        <div>
          <HeaderResults title={company.co_name} alt={company.co_name}>
            {company.co_name}
          </HeaderResults>
          <ContentResults>{text}</ContentResults>
          <div style={{ position: "relative" }}>
            {company?.company_events.map((c, ind) => {
              const foundChannel = channels.find(chann => chann.id === c.event_type);
              if (!foundChannel) {
                return null;
              }
              return (
                <ImgHolder title={foundChannel.name} key={`${foundChannel.icon}_${ind}`}>
                  <Img
                    style={{
                      filter: `opacity(1) drop-shadow(20px 0px 0px ${
                        foundChannel.color.includes("#")
                          ? foundChannel.color
                          : `#${foundChannel.color}`
                      })`,
                    }}
                    src={getIconFromId(foundChannel.icon)}
                    alt="company-img"
                  />
                </ImgHolder>
              );
            })}
          </div>
        </div>
      </FlexContainer>
      <FlexContainerBranches>
        {branches.length > 4 && !showMore
          ? branches.slice(0, 4).map(branch => (
              <Branch key={branch?.wz2008_text} title={branch?.wz2008_text}>
                {branch?.wz2008_text}
              </Branch>
            ))
          : branches.map(branch => (
              <Branch key={branch?.wz2008_text} title={branch?.wz2008_text}>
                {branch?.wz2008_text}
              </Branch>
            ))}
        {branches.length > 4 && (
          <ButtonMore
            type="button"
            onClick={e => {
              e.stopPropagation();
              setShowMore(!showMore);
              scrollTo(index);
            }}
          >
            {showMore ? "weniger anzeigen" : "mehr anzeigen"}
          </ButtonMore>
        )}
      </FlexContainerBranches>
      <FlexContainer>
        <IconContainer
          type="button"
          title={foundRoute ? "Route Löschen" : "Route hinzufügen"}
          alt={foundRoute ? "Route Löschen" : "Route hinzufügen"}
          onClick={e => {
            e.stopPropagation();
            setSelectedRoute(oldVals => {
              if (foundRoute) {
                return oldVals.filter(comp => comp.id !== company.id);
              }

              return [...oldVals, company];
            });
          }}
        >
          <LocationOn style={{ color: foundRoute ? theme.primaryColor : theme.black100 }} />
        </IconContainer>
	<IconContainer
          title={showStar ? (company.favorite ? "Aus den Favoriten entfernen" : "Zu den Favoriten hinzufügen") : "Setzen als Favorit nicht möglich"}
          alt={showStar ? (company.favorite ? "Aus den Favoriten entfernen" : "Zu den Favoriten hinzufügen") : "Setzen als Favorit nicht möglich"}
          onClick={async e => {
            e.stopPropagation();
            await showStar && handleCompanyFavorite(company.id);

          }}
         > 
         {showStar? (company.favorite ? <Star /> : <StarBorder />) : <StarBorder style={{ color: theme.whiteBackground }} />}
        </IconContainer>
      </FlexContainer>
    </SingleResultContainer>
  );
}

export default renderCompany;
